import { render } from "./MaintenancePage.vue?vue&type=template&id=5c4708dc&scoped=true"
const script = {}

import "./MaintenancePage.vue?vue&type=style&index=0&id=5c4708dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c4708dc"]])

export default __exports__